<template>
  <div>
  <v-timeline-item
    v-for="item in historyItems"
    :color="item.icon.color"
    :icon="item.icon.code"
    v-bind:key="item.id"
    fill-dot
    small
    class="py-2"
  >
    <v-row no-gutters align="center" class="mb-1">
      <span class="text-body-2 font-weight-medium mr-1">{{ item.user }}</span>
      <span class="text-body-2">{{ item.type }}</span>
      <v-spacer />
      <v-icon small class="mr-1">mdi-clock</v-icon>
      <span class="text-caption grey--text">{{ item.time }}</span>
    </v-row>

    <v-row v-if="item.description" no-gutters>
      <v-col>
        <span class="text-caption font-italic">{{ item.description }}</span>
      </v-col>
    </v-row>
  </v-timeline-item>
  </div>
</template>

<script>
export default {
    props: {
        historyItems: {
            type: Array,
        },
    },
};
</script>